import call from "@brainspore/celadon-base/service/http";
import withdrawalConstants from "./withdrawalConstants";
import ExemptionConstants from "@/packages/exemptions/ExemptionConstants";
import { helper } from "../../../dashboard/utils";

export default {
  namespaced: true,
  state: {
    withdrawals: [],
    withdrawal: {},
    attachmentDialog: false,
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    withdrawalGetters: (state) => (val) => state[val],
  },
  actions: {
    // GET withdrawals
    getExamWithdrawals: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", withdrawalConstants.EXAM_WITHDRAWALS, payload)
        .then((res) => {
          commit("MUTATE", {
            state: "withdrawals",
            data: res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // GET withdrawal
    getExamWithdrawal: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", withdrawalConstants.EXAM_WITHDRAWAL(helper.decrypt(payload)))
        .then((res) => {
          commit("MUTATE", { state: "withdrawal", data: res.data.data[0] });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // POST Deferrals
    examWithdrawals: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", withdrawalConstants.EXAM_WITHDRAWALS, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          dispatch("getExamWithdrawals");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // PATCH withdrawal entry
    updateWithdrawal: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", withdrawalConstants.UPDATE_WITHDRAWAL, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Updated Withdrawal Entry");
          Event.$emit("back");
          dispatch("getExamWithdrawals");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    setAttachmentDialog({ commit }, payload) {
      commit("MUTATE", { state: "attachmentDialog", data: payload });
    },
    deleteWithdrawal({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", withdrawalConstants.DELETE_EXAM_WITHDRAWAL, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully deleted withdrawal entry");
          dispatch("getExamWithdrawals");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    deleteAttachment({ commit, dispatch }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ExemptionConstants.deleteAttachment, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully deleted Attachment");
          dispatch("getExamWithdrawal", helper.encrypt(payload.documentNo));
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
